/* global requestsUrl */

import React, { Fragment } from 'react';

import { Droppable } from 'react-beautiful-dnd';

import Pack from './Pack';

export default function PackList({ packs }) {
    return (
        <div className="tw-space-y-2">
            {(!!packs.length &&
                packs.map((pack, i) =>
                    pack.deleted ? (
                        ''
                    ) : (
                        <Fragment key={pack.id}>
                            {!!pack.can_be_edited && (
                                <Droppable droppableId={pack.id.toString()}>
                                    {(provided, snapshot) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps}>
                                            <Pack pack={pack} i={i} requestsUrl={requestsUrl} />
                                            <div className="d-none">{provided.placeholder}</div>
                                        </div>
                                    )}
                                </Droppable>
                            )}
                            {!pack.can_be_edited && <Pack pack={pack} i={i} requestsUrl={requestsUrl} />}
                        </Fragment>
                    ),
                )) || <NoPacksFound />}
        </div>
    );
}

const NoPacksFound = () => {
    return <p className="tw-text-sm tw-text-charcoal-50">{$t('No packs found')}</p>;
};
